import { createContext } from 'react';

import { TBreadCrumb } from '@shared/ui/BreadCrumbs/model/index.type';
import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';
import { TFileId } from '@widgets/Files/model/types/fileId.type';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';
import { TFilesModalMode } from '@widgets/Files/model/types/modalMode.type';

interface IContextFiles {
    modalMode: TFilesModalMode;
    onBreadCrumbClick: (breadCrumbId: TBreadCrumb['id']) => void;
    onHideModal: () => void;
    onChangeModalMode: (mode: TFilesModalMode) => void;
    onChangeCurrentFile: (fileId: TFileId, fileInfo: IFIleEntity) => void;
    onChangeCurrentDraggedFolder: (folderId: TFolderId | null) => void;
    // onChangeCurrentFile: (fileId: TFileId) => void;
    onChangeCurrentFolder: (folderId: TFolderId) => void;
    onChangeCurrentFolderInDropdown: (folderId: TFolderId) => void;
    currentFileId: TFileId;
    currentFileInfo: IFIleEntity | null;
    currentFolderId: TFolderId;
    currentFolderDropdownId: TFolderId;
    currentDraggedFolder: TFolderId | null;
}

export const ContextFiles = createContext<IContextFiles | null>({
    currentFileId: null,
    currentFileInfo: null,
    currentFolderId: 0,
    currentFolderDropdownId: null,
});
